import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { SeTimePickerComponent } from './se-time-picker/se-time-picker.component';
import { SeDatetimePickerComponent } from './se-datetime-picker/se-datetime-picker.component';
import { SeFromToComponent } from './se-from-to/se-from-to.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { SeUiControlsModule } from '@se/se.ui.html5';
import { SeDateRangeComponent } from './se-date-range/se-date-range.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatTooltipModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatMenuModule,
        NgxMaterialTimepickerModule,
        SeUiControlsModule,
    ],
    declarations: [SeTimePickerComponent, SeDatetimePickerComponent, SeFromToComponent, SeDateRangeComponent],
    exports: [SeTimePickerComponent, SeDatetimePickerComponent, SeFromToComponent, SeDateRangeComponent],
})
export class SePickersModule {}
